import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ButtonTransparent from "../../components/button/ButtonTransparent";
import noMusicImg from "../../media/images/no-music-2.png";
import { addPlaylist, addToPlaylist, setselectedAddPlaylist } from "../../redux/actions/music";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { setNotification } from "../../redux/actions/styles";

const PlaylistPopup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { playlist, playlistMusic, selectedAddPlaylist } = useSelector((state) => state.music);
  const [selectedPlaylist, setselectedPlaylist] = useState([]);
  const [createPlaylist, setcreatePlaylist] = useState(false);
  const [value, setvalue] = useState("");
  const [focused, setfocused] = useState(false);
  const [selectedAddPlaylistDisplay, setselectedAddPlaylistDisplay] = useState(selectedAddPlaylist);
  const valueLimit = 20;

  function onClickItem(ref) {
    if (selectedPlaylist.includes(ref)) {
      const newSelectedPlaylist = selectedPlaylist.filter((item) => item !== ref);
      setselectedPlaylist(newSelectedPlaylist);
    } else {
      setselectedPlaylist([...selectedPlaylist, ref]);
    }
  }

  useEffect(() => {
    scrollRef.current.scroll({ top: 5000, behavior: "smooth" });
  }, [playlist]);

  useEffect(() => {
    selectedAddPlaylist && setselectedAddPlaylistDisplay(selectedAddPlaylist);
  }, [selectedAddPlaylist]);

  return (
    <div className={`playlist-popup ${selectedAddPlaylist ? "playlist-popup-open" : ""}`}>
      <div
        className="bg-dark"
        onClick={() => {
          setselectedPlaylist([]);
          setcreatePlaylist(false);
          dispatch(setselectedAddPlaylist(null));
        }}
      />
      <div className="playlist-container">
        <h3 className="title">Select single or multiple playlist to add</h3>

        <div className="selected-music">
          <div className="img">
            {selectedAddPlaylistDisplay ? (
              <img src={selectedAddPlaylistDisplay.img} alt={selectedAddPlaylistDisplay.name} />
            ) : (
              <img src={noMusicImg} alt="no music img" />
            )}
          </div>
          <div className="details">
            <h3>{selectedAddPlaylistDisplay ? selectedAddPlaylistDisplay.name : ""}</h3>
            <p>{selectedAddPlaylistDisplay ? selectedAddPlaylistDisplay.artist : ""}</p>
          </div>
        </div>

        <div className="list" ref={scrollRef}>
          {playlist.map((item) => (
            <div
              key={item.ref}
              className={`item ${selectedPlaylist.includes(item.ref) ? "item-active" : ""}`}
              onClick={() => onClickItem(item.ref)}
            >
              {playlistMusic[item.ref].music.length <= 1 ? (
                <div className="img-grid-1">
                  {playlistMusic[item.ref].music[0] ? (
                    <img src={playlistMusic[item.ref].music[0].img} alt={playlistMusic[item.ref].music[0].name} />
                  ) : (
                    <img src={noMusicImg} alt="no music img" />
                  )}
                </div>
              ) : (
                <div className="img-grid-4">
                  {playlistMusic[item.ref].music[0] ? (
                    <img src={playlistMusic[item.ref].music[0].img} alt={playlistMusic[item.ref].music[0].name} />
                  ) : (
                    <img src={noMusicImg} alt="no music img" />
                  )}
                  {playlistMusic[item.ref].music[1] ? (
                    <img src={playlistMusic[item.ref].music[1].img} alt={playlistMusic[item.ref].music[1].name} />
                  ) : (
                    <img src={noMusicImg} alt="no music img" />
                  )}
                  {playlistMusic[item.ref].music[2] ? (
                    <img src={playlistMusic[item.ref].music[2].img} alt={playlistMusic[item.ref].music[2].name} />
                  ) : (
                    <img src={noMusicImg} alt="no music img" />
                  )}
                  {playlistMusic[item.ref].music[3] ? (
                    <img src={playlistMusic[item.ref].music[3].img} alt={playlistMusic[item.ref].music[3].name} />
                  ) : (
                    <img src={noMusicImg} alt="no music img" />
                  )}
                </div>
              )}
              <p>{item.name}</p>
            </div>
          ))}
        </div>
        {createPlaylist && (
          <>
            <div className={`input ${focused ? "focused" : ""}`}>
              <input
                type="text"
                placeholder="Enter your playlist name"
                value={value}
                onChange={(e) =>
                  e.target.value.length <= valueLimit && setvalue(e.target.value.replace(/[^\w\s]/gi, ""))
                }
                onFocus={() => setfocused(true)}
                onBlur={() => setfocused(false)}
              />
            </div>
            <div className="char">
              {value.length}/{valueLimit}
            </div>
          </>
        )}
        {createPlaylist ? (
          <div className="actions">
            <ButtonTransparent
              text="Go back"
              onClick={() => {
                setcreatePlaylist(false);
                setvalue("");
              }}
            />
            <ButtonTransparent
              text="Create and add"
              onClick={() => {
                // dispatch(setselectedAddPlaylist(null));
                dispatch(addPlaylist(value ? value : `Playlist ${playlist.length + 1}`));
                setcreatePlaylist(false);
                setvalue("");
              }}
            />
          </div>
        ) : (
          <div className="actions">
            <ButtonTransparent
              iconLeft={<AddIcon />}
              text="Create new playlist"
              onClick={() => {
                // dispatch(setselectedAddPlaylist(null));
                setcreatePlaylist(true);
              }}
            />
            <ButtonTransparent
              text="Add to playlist"
              onClick={() => {
                dispatch(
                  setNotification({
                    active: true,
                    loading: false,
                    error: false,
                    message: `Saved successfully to playlist${selectedPlaylist.length === 1 ? "" : "s"}!`,
                  })
                );
                dispatch(addToPlaylist(selectedPlaylist, selectedAddPlaylist));
                setselectedPlaylist([]);
                dispatch(setselectedAddPlaylist(null));

                setTimeout(() => {
                  dispatch(
                    setNotification({
                      active: false,
                      loading: false,
                      error: false,
                      message: `Saved successfully to playlist${selectedPlaylist.length === 1 ? "" : "s"}!`,
                    })
                  );
                }, 1000);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaylistPopup;
